import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { TrustRow } from './TrustRow';
import { Countdown } from '../hooks/useCountdown';
const EBOOK_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/bb28f6c3-2bdf-49c3-90fd-8692cdb321cb.jpg';
const GYM_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/1467ecb8-58e5-4ffa-bcfa-5967fdf85965.jpg';
type HeroProps = {
  checkoutUrl: string;
  countdown: Countdown;
};
export function Hero({
  checkoutUrl,
  countdown
}: HeroProps) {
  return <header className="relative overflow-hidden border-b border-white/5 bg-ink-950" data-id="element-38" data-mp="sarvuvlzhael">
      <img src={GYM_BG} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.18]" data-id="element-39" data-mp="nc87ypntxojl" />
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_bottom,rgba(7,7,10,0.7),rgba(7,7,10,0.96))]" aria-hidden="true" data-id="element-40" data-mp="3czfny6wb6l9q" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 pb-16 pt-12 lg:grid-cols-[1.15fr_0.85fr] lg:gap-10 lg:pb-24 lg:pt-16" data-id="element-41" data-mp="3j925dog4jqvj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-42" data-mp="39ala4fa5kq3o">
          <p className="inline-flex items-center rounded-full border border-flame/30 bg-flame/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-flame-400" data-id="element-43" data-mp="3eb92b4a4bczh">
            Para latinos en USA · 100% en español
          </p>

          <h1 className="mt-5 font-display text-[2.6rem] font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-[4.1rem]" data-id="element-44" data-mp="2qkmrj58qbels">
            ¿Tu primer día en el gym y{' '}
            <span className="text-flame" data-id="element-45" data-mp="2hincgih9yklh">no sabes ni por dónde empezar?</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/70 sm:text-xl" data-id="element-46" data-mp="2lla5untlgdks">
            Deja de sentir vergüenza. Entra con confianza con el <strong className="font-semibold text-white" data-id="element-47" data-mp="s3mahuslbkuo">plan exacto de 30 días</strong> que te
            dice qué máquinas usar, cómo entrenar y qué comer. Todo en español.
          </p>

          <div className="mt-8" data-id="element-48" data-mp="id050tel8app">
            <CtaButton href={checkoutUrl} className="w-full sm:w-auto" data-id="element-49" data-mp="i9vr34bbm0lu">
              ¡Quiero empezar sin miedo ahora!
            </CtaButton>
          </div>

          <div className="mt-6 flex flex-col gap-5 sm:flex-row sm:items-end sm:gap-8" data-id="element-50" data-mp="1azktnm3oi8pk">
            <CountdownTimer countdown={countdown} label="Oferta de lanzamiento expira en:" data-id="element-51" data-mp="161j7utevbvae" />
            <p className="text-sm text-white/50" data-id="element-52" data-mp="111yd6v6qe93h">
              <span className="font-display text-2xl font-black text-white" data-id="element-53" data-mp="114suidug7dso">$7</span>
              <span className="ml-1 line-through decoration-flame/70" data-id="element-54" data-mp="x0uw65cy670o">$27</span>
              <br data-id="element-55" data-mp="3ltqe5h5gv3vm" />
              Pago único · acceso inmediato
            </p>
          </div>

          <TrustRow className="mt-7" data-id="element-56" data-mp="3hqalsx0fjpoq" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-sm lg:max-w-none" data-id="element-57" data-mp="1x9b0yopm2f6r">
          <div className="absolute inset-x-6 bottom-6 top-10 rounded-[2rem] bg-flame/20 blur-2xl" aria-hidden="true" data-id="element-58" data-mp="267whyfffpm5f" />
          <img src={EBOOK_IMG} alt="Mockup del eBook Gym por Primera Vez en versión impresa y digital" className="relative w-full rounded-2xl" loading="eager" data-id="element-59" data-mp="2g0lqp2jlolx2" />
          <div className="relative -mt-4 flex justify-center" data-id="element-60" data-mp="2p1sapllgkev2">
            <span className="rounded-full border border-white/10 bg-ink-850 px-4 py-2 text-xs font-bold uppercase tracking-[0.12em] text-white/70" data-id="element-61" data-mp="2u03mi1vbczfx">
              PDF · 68 páginas · léelo en el celular
            </span>
          </div>
        </motion.div>
      </div>
    </header>;
}